/* NotSupportedInTheBrowserAlias.js */

//This was added to bring in support for node-bunyan (April 2015). Node-bunyan requires fs and dtrace-provider and this little trick gets us around the issue in the browser.
//If this can be done another way in the future DO IT!!!
module.exports = null;